// One place for "which statuses make sense for this person?", used by the Directory (Master
// Database) status dropdown and by the Home page "Upcoming & Overdue" popup, so both always
// follow the same rule.
import dayjs from "dayjs";

export const STATUS_OPTIONS = [
  { label: "Onboarding", value: "Onboarding" },
  { label: "Awaiting Start Date", value: "Awaiting Start Date" },
  { label: "On Hold", value: "Hold" },
  { label: "Lost", value: "Lost" },
  { label: "Live", value: "Live" },
  { label: "Exit", value: "Exit" },
];

const MONTHS = {
  jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
  jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11,
};

// Accepts 'YYYY-MM-DD[ ...]' (the dashboard API) and 'DD-MMM-YY' / 'DD-MMM-YYYY' (the list API).
export const parseDate = (value) => {
  if (!value) return null;
  const text = String(value).trim();
  let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(text);
  if (m) return dayjs(new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  m = /^(\d{1,2})-([A-Za-z]{3})-(\d{2,4})$/.exec(text);
  if (m && MONTHS[m[2].toLowerCase()] !== undefined) {
    const year = m[3].length === 2 ? 2000 + Number(m[3]) : Number(m[3]);
    return dayjs(new Date(year, MONTHS[m[2].toLowerCase()], Number(m[1])));
  }
  return null;
};

const fmt = (d) => d.format("DD-MMM-YYYY");

// Only people who are still "active" are restricted by their dates. Exit / Lost are final
// states that someone may deliberately correct, so they keep the full list.
const ACTIVE = new Set(["Onboarding", "Awaiting Start Date", "Live", "Hold"]);

/**
 * statusChoices({ status, startDate, endDate }) -> { options, note }
 *  - end date has passed   -> the only valid status is Exit
 *  - start date has passed -> no more Onboarding / Awaiting Start Date
 * `options` never contains the current status (there is nothing to change to).
 * `note` explains the restriction ("" when there is none).
 */
export const statusChoices = ({ status, startDate, endDate }) => {
  const today = dayjs().startOf("day");
  const start = parseDate(startDate);
  const end = parseDate(endDate);
  let options = STATUS_OPTIONS;
  let note = "";
  if (ACTIVE.has(status)) {
    if (end && end.isBefore(today, "day")) {
      options = STATUS_OPTIONS.filter((o) => o.value === "Exit");
      note = `End date (${fmt(end)}) has already passed, so the only valid status is Exit.`;
    } else if (start && start.isBefore(today, "day")) {
      options = STATUS_OPTIONS.filter(
        (o) => o.value !== "Onboarding" && o.value !== "Awaiting Start Date"
      );
      note = `Start date (${fmt(start)}) has already passed, so Onboarding and Awaiting Start Date are not available.`;
    }
  }
  return { options: options.filter((o) => o.value !== status), note };
};
